import { ApiError } from '../common/ApiError';
import { request } from '../common/http';
import type { SetDaysOffCommand, TeamMember } from './models';

export type TeamMemberWithEtag = {
    member: TeamMember;
    etag: string;
};

export const getByEmail = async (email: string): Promise<TeamMemberWithEtag | null> => {
    try {
        const { data, headers } = await request<TeamMember>({
            method: 'GET',
            path: `/team-members/${encodeURIComponent(email)}`,
        });
        const etag = headers.get('etag') ?? '';
        return { member: data, etag };
    } catch (e) {
        if ((e as ApiError).status === 404) {
            return null;
        }
        throw e;
    }
};

export const setDaysOff = async (email: string, cmd: SetDaysOffCommand, ifMatch: string): Promise<TeamMemberWithEtag> => {
    const { data, headers } = await request<TeamMember>({
        method: 'POST',
        path: `/team-members/${encodeURIComponent(email)}/days-off`,
        ifMatch,
        body: cmd,
    });
    const etag = headers.get('etag') ?? '';
    return { member: data, etag };
};
